import { PermissionMiddleware } from '../permissionInterface';
import { createPermissionSubscriptionMiddleware } from './subscription';

export function createPermissionBillingMiddleware(): PermissionMiddleware[] {
    return [createPermissionSubscriptionMiddleware()];
}
